import { createContext, RefObject } from "react";

export type ModalContextType = {
    /**
     * A ref to the modal that contains the grid.
     */
    modalRef?: RefObject<HTMLDivElement>;
};

export const ModalContext = createContext<ModalContextType>({});
